import { render, staticRenderFns } from "./InviteOrganization.vue?vue&type=template&id=a9c1ac20&"
import script from "./InviteOrganization.vue?vue&type=script&lang=js&"
export * from "./InviteOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports